import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Divider } from 'semantic-ui-react';
import { withRouterWorkaround } from 'utils/workaroundUtils';
import styled from 'styled-components';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { RouterProps } from 'react-router';
import { BillPaymentSearchResponse } from 'ts-types/api.types';
import ManualPaymentSearchView from 'components/payment/ManualPaymentSearchView';
import ManualPaymentTableView from 'components/payment/ManualPaymentTableView';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends MessageSourceProps, RouterProps, PatientConsumerRenderProps {
}

interface State {
  billsKey: number,
  bills: Array<BillPaymentSearchResponse>,
  billsLoading: boolean
}

class ManualPaymentView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      billsKey: 1,
      bills: [],
      billsLoading: false
    }
  }

  onFilterBills = (bills: Array<BillPaymentSearchResponse>) => {
    this.setState({
      bills: bills
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

  clearTableView = () => {
    this.setState( {
      billsKey: this.state.billsKey + 1
    })
  };

  render(): React.ReactNode {

    const {billsKey, bills, billsLoading} = this.state;
    const {currentPatient, getMessage, onPatientRefresh} = this.props;

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.manualPayment")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledPraxSegment>
            <ManualPaymentSearchView
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
                currentPatient={currentPatient}
            />
            <Divider/>
            <ManualPaymentTableView
                key={billsKey}
                bills={bills}
                billsLoading={billsLoading}
                currentPatient={currentPatient}
                onPatientRefresh={onPatientRefresh}
                resetBills={this.clearTableView}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  }
}

export default withRouterWorkaround(withPatientContext(withMessages(ManualPaymentView)));
